import React from 'react';
import { observer } from 'mobx-react';

import { ApplicationModule } from 'shared/modules';
import { UiGrid, UiNavLink } from 'shared/uikit';
import { ROUTES } from "shared/constants";
import { useMedia } from "shared/hooks";

import './styles.scss';
import { PProfileTinets } from "pages/profile/components/PProfileTinets";
import { PProfileLeague } from "pages/profile/components/PProfileLeague";

export const PProfileUser = observer(() => {
    const { value: userFieldsColumns } = useMedia({ is320: 1, is1440: 2, is1920: 3 });

    const isWidgetsLeague = () => {
        return ApplicationModule.user.tinetsWidgets?.find(item => item.typeId === "league_rating") ? true : false;
    }

    return (
        <>
            <div className="p-user-section p-user-section">
                <div className="p-user__small-name">{ ApplicationModule.user.previewName }</div>

                {ApplicationModule.user.departmentBranch && (
                    <div className="p-user__depatment">
                        {ApplicationModule.user.userPositionName && (
                            <div className="p-user__depatment-position">{ApplicationModule.user.userPositionName}</div>
                        )}

                        <div className="p-user__depatment-list">
                            <UiNavLink
                                to={ROUTES.DEPARTMENT_BRANCH(ApplicationModule.user.departmentBranch.id)}
                                className="p-user__depatment-item p-user__depatment-item--link"
                            >
                                {ApplicationModule.user.departmentBranch?.name}
                            </UiNavLink>
                            <UiNavLink
                                to={ROUTES.DEPARTMENT(ApplicationModule.user.departmentBranch?.department?.id)}
                                className="p-user__depatment-item p-user__depatment-item--link"
                            >
                                {ApplicationModule.user.departmentBranch?.department?.name}
                            </UiNavLink>
                        </div>
                    </div>
                )}
            </div>

            {
                ApplicationModule.user.tinetsUserStat && !Array.isArray(ApplicationModule.user.tinetsUserStat) ?
                    <PProfileTinets user={ApplicationModule.user} isProfile={true} />
                    : ''
            }

            {
                isWidgetsLeague() ?
                    <PProfileLeague user={ApplicationModule.user} />
                    : ""
            }

            <div className="p-user-section">
                <div className="p-user-section__title">Контактные данные</div>
                <div className='p-user-fields'>
                    {ApplicationModule.user.phone && (
                        <div className="p-user-fields__field">
                            <div className="p-user-fields__name">Добавочный номер</div>
                            <div className="p-user-fields__value">{ApplicationModule.user.phone}</div>
                        </div>
                    )}
                    {ApplicationModule.user.mobile && (
                        <div className="p-user-fields__field">
                            <div className="p-user-fields__name">Мобильный телефон</div>
                            <div className="p-user-fields__value">{ApplicationModule.user.mobile}</div>
                        </div>
                    )}
                    {ApplicationModule.user.email && (
                        <div className="p-user-fields__field">
                            <div className="p-user-fields__name">Е-mail</div>
                            <a
                                href={`mailto:${ApplicationModule.user.email}`}
                                className="p-user-fields__value p-user-fields__value--email"
                            >
                                {ApplicationModule.user.email}
                            </a>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
});
